export default __webpack_public_path__ + "static/media/19.9c8d237e.jpeg";